<template>
	<tr class="step-analytics-row" :class="{deleted: step.is_deleted, clickable:clickable, open:open}" :data-id="step.step_id">
		<td class="step-name-td" @click="$emit('click')">
			<div class="step-name">
				<inline-svg v-if="clickable" class="arrow" :src="require('@/assets/img/arrow-bottom.svg')" />
				<strong v-if="step.is_deleted" class="name">{{ step.step_name }}</strong>

<!--				<router-link v-else :to="'/wfunnel/'+$route.params.id+'/steps/'+step.step_id">-->
					<strong class="name">{{ step.step_name }}</strong>
<!--				</router-link>-->
			</div>
		</td>

		<td class="conv-rate-td">
			<span class="bar"
			      :style="`width:${Math.max(1, Math.min(percentage(step.orders, step.visits), 100))}%`" />
			<value-diff :value="percentage(step.orders, step.visits)"
			            :old-value="percentage(step.old_visits, step.old_visits)"
			            suffix="%" :digits="2" />
		</td>

		<td >
			<value-diff :value="step.visits" :old-value="step.old_visits" suffix="" />
		</td>

		<td >
			<value-diff :value="step.revenue" :old-value="step.old_revenue"
			            :prefix="currencyCode" is-money />
		</td>
		<td >
			<value-diff :value="step.orders" :old-value="step.old_orders" suffix="" />
		</td>
		<td >
			<value-diff :value="step.optins" :old-value="step.old_optins" suffix="" />
		</td>
		<td >
			<value-diff :value="percentage(step.optins, step.visits)"
			            :old-value="percentage(step.old_optins, step.old_visits)"
			            suffix="%" :digits="2" />
		</td>
	</tr>

</template>

<script>
import ValueDiff from "@/views/funnels/funnel/valueDiff";
import {percentage} from "@/helpers/analytics";
import {mapGetters} from "vuex";
import {getSymbol} from "@/helpers/currencies";

export default {
	name: "StepAnalyticsRow", components: {ValueDiff},
	props: ["step",'open'],
	data() {
		return {}
	},
	computed:{
		...mapGetters(["getFunnelStore",]),
		clickable(){
			return this.step.pages.length>1;
		},
		currencyCode() {
			let currency = this.getFunnelStore.currency_code;
			return getSymbol(currency);
		},
	},
	methods:{
		percentage(sub,total) {
			return percentage(sub,total)
		},
	}
}
</script>

<style lang="scss" scoped>
.step-analytics-row {
	&.clickable {
		.step-name {
			.arrow {
				margin-right: 5px;

			}
			.arrow {
				position: absolute;
				left: -20px;
			}
		}
		&.open{
			.arrow {
				transform: rotate(180deg);
			}
		}
		.step-name-td:hover {
			cursor: pointer;
			.name {
				color: $sharp-blue;
			}
		}
	}
	td:first-child {
		padding-left: 30px;
		width: auto;
	}
	&.deleted {
		.step-name {
			.name {
				pointer-events: none;
			}
		}
	}
}
</style>
